import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

const NotFound = () => import(/* webpackChunkName: "NotFound" */ '@/pages/GeneralViews/NotFoundPage')
const Forbidden = () => import(/* webpackChunkName: "NotFound" */ '@/pages/GeneralViews/ForbiddenPage')
const Login = () => import(/* webpackChunkName: "Login" */ '@/pages/Auth/Login.vue')
const Logout = () => import(/* webpackChunkName: "Logout" */ '@/pages/Auth/Logout.vue')
const AuthLayout = () => import(/* webpackChunkName: "GeneralScreenDashboard" */ '@/pages/Layouts/AuthLayout.vue')
const GeneralScreenDashboard = () => import(/* webpackChunkName: "GeneralScreenDashboard" */ '@/pages/Layouts/GeneralScreenDashboard.vue')
const EmptyContent = () => import(/* webpackChunkName: "GeneralScreenDashboard" */ '@/pages/Layouts/EmptyContent.vue')
const Dashboard = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Dashboard/index.vue')
const ImportAnggaran = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Dashboard/ImportAnggaran.vue')

const SettingForm = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Setting/Form.vue')

const SchoolList = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/School/List.vue')
const SchoolForm = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/School/Form.vue')
const SchoolDetail = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/School/Detail.vue')

const KodeRekeningList = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/KodeRekening/List.vue')
const KodeRekeningForm = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/KodeRekening/Form.vue')
const KodeRekeningDetail = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/KodeRekening/Detail.vue')

const KodeKegiatanList = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/KodeKegiatan/List.vue')
const KodeKegiatanForm = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/KodeKegiatan/Form.vue')
const KodeKegiatanDetail = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/KodeKegiatan/Detail.vue')

const RkasList = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Rkas/List.vue')
const RkasForm = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Rkas/Form.vue')
const RkasDetail = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Rkas/Detail.vue')

const RekapitulationList = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Rekapitulation/List.vue')
const RekapitulationForm = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Rekapitulation/Form.vue')
const RekapitulationDetail = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Rekapitulation/Detail.vue')

const PlanningList = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Planning/List.vue')
const PlanningForm = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Planning/Form.vue')
const PlanningDetail = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Planning/Detail.vue')

const RealizationList = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Realization/List.vue')
const RealizationForm = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Realization/Form.vue')
const RealizationDetail = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Realization/Detail.vue')

const ReportList = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Report/List.vue')
const ReportCheck = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/Report/Check.vue')

const SchoolFileAssetList = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/SchoolFileAsset/List.vue')
const SchoolFileAssetPreview = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/SchoolFileAsset/FilePreview.vue')
const SchoolFileAssetForm = () => import(/* webpackChunkName: "Dashboard" */ '@/pages/SchoolFileAsset/Form.vue')

const routes = [
    {
      path: '/auth',
      redirect: '/auth/login',
      component: AuthLayout,
      children: [
        {
          path: 'login',
          name: 'Login Account',
          component: Login
        }
      ],
      meta: { requireGuest: true }
    }, {
      path: '/logout',
      component: Logout,
      meta: { requireAuth: true }
    }, {
      path: '/file-preview/:id',
      name: 'file-preview',
      component: SchoolFileAssetPreview,
      meta: { title: 'Preview File', neeedRole: ['admin-sekolah', 'super-admin'] }
    }, {
      path: '/',
      component: GeneralScreenDashboard,
      children: [
        {
          path: '/',
          name: 'Homepage',
          redirect: 'beranda',
          meta: { requireAuth: true },
        }, {
          path: 'beranda',
          // alias: '/',
          name: 'dashboard',
          component: Dashboard,
          meta: { title: 'Beranda', requireAuth: true },
        }, {
          path: 'import-anggaran',
          // alias: '/',
          name: 'import-anggaran',
          component: ImportAnggaran,
          meta: { title: 'Import Anggaran', requireAuth: true },
        }, {
          path: '/sekolah',
          name: 'Sekolah',
          component: EmptyContent,
          children: [
            {
              path: 'index',
              alias: '/',
              name: 'Kelola Sekolah',
              component: SchoolList,
              meta: { title: 'Kelola Sekolah', neeedRole: ['super-admin'] }
            },
            {
              path: 'create',
              name: 'Informasi Sekolah',
              component: SchoolForm,
              meta: { title: 'Informasi Sekolah', neeedRole: ['super-admin'] }
            },
            {
              path: ':id',
              name: 'Detail Data Sekolah',
              component: SchoolDetail,
              meta: { title: 'Detail Data Sekolah', neeedRole: ['super-admin'] }
            },
            {
              path: ':id/edit',
              name: 'Edit Data Sekolah',
              component: SchoolForm,
              meta: { title: 'Edit Data Sekolah', neeedRole: ['super-admin'] }
            }
          ]
        }, {
          path: '/manajer-file-asset',
          name: 'manajer-file-asset',
          component: EmptyContent,
          children: [
            {
              path: 'index',
              alias: '/',
              name: 'manajer-file-asset.index',
              component: SchoolFileAssetList,
              meta: { title: 'Manajer File Bukti', neeedRole: ['admin-sekolah'] }
            },
            {
              path: 'create',
              name: 'manajer-file-asset.create',
              component: SchoolFileAssetForm,
              meta: { title: 'Tambah Manajer File Bukti', neeedRole: ['admin-sekolah'] }
            },
          ]
        }, {
          path: '/kode-kegiatan',
          name: 'kode-kegiatan',
          component: EmptyContent,
          children: [
            {
              path: 'index',
              alias: '/',
              name: 'kode-kegiatan.index',
              component: KodeKegiatanList,
              meta: { title: 'Kelola Kode Kegiatan', neeedRole: ['super-admin'] }
            },
            {
              path: 'create',
              name: 'kode-kegiatan.create',
              component: KodeKegiatanForm,
              meta: { title: 'Informasi Kode Kegiatan', neeedRole: ['super-admin'] }
            },
            {
              path: ':id',
              name: 'kode-kegiatan.detail',
              component: KodeKegiatanDetail,
              meta: { title: 'Detail Data Kode Kegiatan', neeedRole: ['super-admin'] }
            },
            {
              path: ':id/edit',
              name: 'kode-kegiatan.edit',
              component: KodeKegiatanForm,
              meta: { title: 'Informasi Kode Kegiatan', neeedRole: ['super-admin'] }
            }
          ]
        }, {
          path: '/kode-rekening',
          name: 'kode-rekening',
          component: EmptyContent,
          children: [
            {
              path: 'index',
              alias: '/',
              name: 'kode-rekening.index',
              component: KodeRekeningList,
              meta: { title: 'Kelola Kode Rekening', neeedRole: ['super-admin'] }
            },
            {
              path: 'create',
              name: 'kode-rekening.create',
              component: KodeRekeningForm,
              meta: { title: 'Informasi Kode Rekening', neeedRole: ['super-admin'] }
            },
            {
              path: ':id',
              name: 'kode-rekening.detail',
              component: KodeRekeningDetail,
              meta: { title: 'Detail Data Kode Rekening', neeedRole: ['super-admin'] }
            },
            {
              path: ':id/edit',
              name: 'kode-rekening.edit',
              component: KodeRekeningForm,
              meta: { title: 'Informasi Kode Rekening', neeedRole: ['super-admin'] }
            }
          ]
        }, {
          path: '/rkas',
          name: 'rkas',
          component: EmptyContent,
          children: [
            {
              path: 'index',
              alias: '/',
              name: 'Rkas List',
              component: RkasList,
              meta: { title: 'RKAS', neeedRole: ['super-admin'] }
            },
            {
              path: 'create',
              name: 'Rkas Create',
              component: RkasForm,
              meta: { title: 'Rkas', neeedRole: ['super-admin'] }
            },
            {
              path: ':id',
              name: 'Detail Data Rkas',
              component: RkasDetail,
              meta: { title: 'Detail Data Rkas', neeedRole: ['super-admin'] }
            },
            {
              path: ':id/edit',
              name: 'Rkas Edit',
              component: RkasForm,
              meta: { title: 'Rkas', neeedRole: ['super-admin'] }
            }
          ]
        },{
          path: '/rekapitulasi',
          name: 'rekapitulation',
          component: EmptyContent,
          children: [
            {
              path: 'index',
              alias: '/',
              name: 'REKAPITULASI',
              component: RekapitulationList, // isi componentnya sama dengan RkasList tetapi ada masalah di update kolom jadi dibuat duplikate
              meta: { title: 'REKAPITULASI', neeedRole: ['super-admin'] }
            },
            {
              path: 'create',
              name: 'Rekapitulasi Create',
              component: RekapitulationForm,
              meta: { title: 'Rekapitulasi', neeedRole: ['super-admin'] }
            },
            {
              path: ':id',
              name: 'Rekapitulasi Detail',
              component: RekapitulationDetail,
              meta: { title: 'Rekapitulasi', neeedRole: ['super-admin'] }
            },
            {
              path: ':id/edit',
              name: 'rkas.edit',
              component: RekapitulationForm,
              meta: { title: 'Infrormasi Sekolah', neeedRole: ['super-admin'] }
            }
          ]
        }, {
          path: '/pengaturan',
          name: 'setting',
          component: EmptyContent,
          children: [
            {
              path: 'index',
              alias: '/',
              name: 'setting index',
              component: SettingForm,
              meta: { title: 'Pengaturan', requireAuth: true },
            }]
        }, {
          path: '/rencana',
          name: 'planning',
          component: EmptyContent,
          children: [
            {
              path: 'index',
              alias: '/',
              name: 'Rencana',
              component: PlanningList,
              meta: { title: 'Rencana', neeedRole: ['admin-sekolah', 'super-admin'] }
            },
            {
              path: 'create',
              name: 'Input Rincian Kertas Kerja Create',
              component: PlanningForm,
              meta: { title: 'Input Rincian Kertas Kerja', neeedRole: ['admin-sekolah'] }
            },
            {
              path: ':id',
              name: 'Detail Data Rencana',
              component: PlanningDetail,
              meta: { title: 'Detail Data Rencana', neeedRole: ['admin-sekolah'] }
            },
            {
              path: ':id/edit',
              name: 'Input Rincian Kertas Kerja Edit',
              component: PlanningForm,
              meta: { title: 'Input Rincian Kertas Kerja', neeedRole: ['admin-sekolah'] }
            }
          ]
        }, {
          path: '/realisasi',
          name: 'realisasi',
          component: EmptyContent,
          children: [
            {
              path: 'index',
              alias: '/',
              name: 'Realisasi',
              component: RealizationList, // isi componentnya sama dengan PlanningList tetapi ada masalah di update kolom jadi dibuat duplikate
              meta: { title: 'Realisasi', neeedRole: ['admin-sekolah', 'super-admin'] }
            },
            {
              path: ':id',
              name: 'Detail Data Realisasi',
              component: PlanningDetail,
              meta: { title: 'Detail Data Realisasi', neeedRole: ['admin-sekolah'] }
            },
          ]
        },
        // {
        //   path: '/realisasi',
        //   name: 'realization',
        //   component: EmptyContent,
        //   children: [
        //     {
        //       path: 'index',
        //       alias: '/',
        //       name: 'Realisasi',
        //       component: RealizationList,
        //       meta: { title: 'Realisasi', neeedRole: ['super-admin'] }
        //     },
        //     {
        //       path: 'create',
        //       name: 'Realisasi Create',
        //       component: RealizationForm,
        //       meta: { title: 'Ralisasi', neeedRole: ['super-admin'] }
        //     },
        //     {
        //       path: ':id',
        //       name: 'Detail Data Realisasi',
        //       component: RealizationDetail,
        //       meta: { title: 'Detail Data Realisasi', neeedRole: ['super-admin'] }
        //     },
        //     {
        //       path: ':id/edit',
        //       name: 'Realisasi Edit',
        //       component: RealizationForm,
        //       meta: { title: 'Realisasi', neeedRole: ['super-admin'] }
        //     }
        //   ]
        // },
        {
          path: '/laporan',
          name: 'report',
          component: EmptyContent,
          children: [
            {
              path: 'index',
              alias: '/',
              name: 'Laporan Realisasi',
              component: RealizationList, // isi componentnya sama dengan PlanningList tetapi ada masalah di update kolom jadi dibuat duplikate
              meta: { title: 'Laporan', neeedRole: ['admin-sekolah', 'super-admin'] }
            },
            // {
            //   path: 'cek',
            //   name: 'report.check',
            //   component: ReportCheck,
            //   meta: { title: 'Laporan', neeedRole: ['super-admin'] }
            // },
          ]
        },
      ],
      meta: { requireAuth: true }
    }, {
      path: '/403',
      component: Forbidden
    }, {
      path: '*', component: NotFound
    }
  ]
  
  Vue.use(VueRouter)
  const router = new VueRouter({
    routes, // short for router: router
    mode: 'history',
    linkActiveClass: 'active'
  })
  
  if (store.getters['account/isLoggedIn']) {
    store.dispatch('account/saveTokens', {tokens: store.getters['account/tokens'], accountData: null, isLocalLogin: true})
  }
  
  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.neeedRole)) {
      if (!store.getters['account/isLoggedIn']) {
        next({
          path: '/auth/login',
          query: { redirect: to.fullPath }
        })
      }
      if (to.meta.neeedRole.includes(store.getters['account/accountData'].role)) {
        next()
      } else {
        next({
          path: '/403'
        })
      }
    } else if (to.matched.some(record => record.meta.requireAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!store.getters['account/isLoggedIn']) {
        next({
          path: '/auth/login',
          query: { redirect: to.fullPath }
        })
      } else if (to.matched.some(record => record.meta.needPermission)) {
        const needPermission = typeof to.meta.needPermission === 'function' ? to.meta.needPermission(to) : to.meta.needPermission
        if (typeof to.meta.needPermission !== 'undefined' && store.getters['account/needPermission'](needPermission)) {
          next()
        } else {
          next({
            path: '/403'
          })
        }
      } else {
        next()
      }
    } else if (to.matched.some(record => record.meta.requireGuest)) {
      if (store.getters['account/isLoggedIn']) {
        next({
          path: '/',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    }  else {
      next()
    }
    window.scrollTo(0, 0)
  })
  
  export default router